// Zentrale Quelle der Top-Kurse — wird im Hero-Featured-Block, im Header-Dropdown
// und im Footer als Direkt-Link-Liste verwendet.
// Reihenfolge = Anzeige-Reihenfolge.
export const FEATURED_COURSE_IDS = [
  "pflegeassistent-lg1-lg2",
  "ambulanter-pflegeassistent",
  "wundexperte",
  "pdl",
  "pflegefachassistent-externenpruefung",
];
